type ErrorLevel = 'info' | 'warning' | 'error' | 'critical';

interface ErrorDetails {
  code?: string;
  message: string;
  level: ErrorLevel;
  timestamp: Date;
  context?: Record<string, any>;
}

class ErrorHandler {
  private static instance: ErrorHandler;
  private errors: ErrorDetails[] = [];

  private constructor() {}

  static getInstance(): ErrorHandler {
    if (!ErrorHandler.instance) {
      ErrorHandler.instance = new ErrorHandler();
    }
    return ErrorHandler.instance;
  }

  handleError(error: Error, level: ErrorLevel = 'error', context?: Record<string, any>) {
    const errorDetails: ErrorDetails = {
      message: error.message,
      level,
      timestamp: new Date(),
      context
    };

    if (error instanceof Error && 'code' in error) {
      errorDetails.code = (error as any).code;
    }

    this.errors.push(errorDetails);
    this.logError(errorDetails);
    this.notifyUser(errorDetails);
  }

  private logError(error: ErrorDetails) {
    if (error.level === 'critical' || error.level === 'error') {
      console.error(`[${error.level.toUpperCase()}]`, error);
    } else {
      console.warn(`[${error.level.toUpperCase()}]`, error);
    }
  }

  private notifyUser(error: ErrorDetails) {
    // Implement user notification logic (toast, alert, etc.)
    if (error.level === 'critical') {
      // Show critical error UI
    }
  }

  getErrors(): ErrorDetails[] {
    return this.errors;
  }

  clearErrors() {
    this.errors = [];
  }
}

export const errorHandler = ErrorHandler.getInstance();